import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { finalize } from 'rxjs/operators';
import { ImageService } from '../shared/services/image.service';
import { SettingService } from '../shared/services/setting.service';
import { ApiControllerService } from '../shared/services/api-controller.service';

export interface IimageLibraryData {
  shortNameReference: string;
  valueImageCollected: string;
}



@Injectable({
  providedIn: 'root'
})
export class HomePageService {

  imageLibrary: IimageLibraryData[] = [];

  isHomePageImageLoaded: boolean = false;

  get gethomepageImageLoaded(): boolean {
    return this.isHomePageImageLoaded;
  }

  constructor(
    private sanitizer: DomSanitizer,
    private settings: SettingService,
    private http: HttpClient,
    private imageService: ImageService,
    private apiController: ApiControllerService
  ) { }



  getImage(path: string): Observable<Blob> {
    return Observable.create(o => {
      /* this.http.post(this.settings.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              // this.alert.showUnexpectedErrorMsg();
              o.error(res);
          }
        ) */
      this.apiController.post(this.settings.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              // this.alert.showUnexpectedErrorMsg();
              o.error(res);
          }
        )
    });
  }


  fetchImage(ImageShortname) {
    return new Promise((resolve, reject) => {
      if (ImageShortname != null && ImageShortname != "") {


        var imageData = this.preloadedImage(ImageShortname);

        if(imageData == "") {

          this.getImage(ImageShortname).subscribe(data => {
            this.imageService.createImageFromBlob(data)
            .pipe(finalize(() => {
                
            }))
            .subscribe(async (buffer) => {
              this.setloadedImage(ImageShortname, this.sanitizer.bypassSecurityTrustStyle(`url(${buffer})`));
              
              resolve(this.sanitizer.bypassSecurityTrustStyle(`url(${buffer})`));
            });       
          }, error => {
          });
        } else {
          resolve(imageData);
        }

      } else {
        resolve(this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/menu/not-found.png)`));
      }
    });
  } 

  /////////////////////////////////////////////////////////////////////////////////
  // icons preload

  setloadedImage(ImageShortname, imageBuffer) {
    var valueReference = {
      shortNameReference: ImageShortname,
      valueImageCollected: imageBuffer
    }

    this.imageLibrary.push(valueReference); 
    
  }

  preloadedImage(ImageShortname): string {
    const match = this.imageLibrary.find(
      item => item.shortNameReference === ImageShortname
    );


    if(match) {
      return match.valueImageCollected;
    } else {
      return "";
    }
  }

  /////////////////////////////////////////////////////////////////////////////////


  
}
